import {connect} from 'react-redux';
import ReportsResets from 'components/pages/Reports/Resets/Resets';

import {setReportSettings} from 'redux/actions/reports';
import {getPasswordResetsReport} from 'api/report';

function mapStateToProps({data}) {
  return {
    settings: data.getIn(['reports', 'passwordResets', 'settings']),
    report: data.getIn(['reports', 'passwordResets', 'data']),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getUsersReport: (...args) => dispatch(getPasswordResetsReport(...args)),
    updateSettings: (...args) => dispatch(setReportSettings('passwordResets', ...args)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ReportsResets);
